export function equalizeHeights(elements: NodeListOf<HTMLElement> | HTMLElement[]): void {
  const items = Array.from(elements);

  items.forEach((element) => {
    element.style.minHeight = '';
  });

  if (items.length < 2) return;

  let maxHeight = 0;
  items.forEach((element) => {
    maxHeight = Math.max(maxHeight, element.getBoundingClientRect().height);
  });

  items.forEach((element) => {
    element.style.minHeight = `${maxHeight}px`;
  });
}
